// https://www.chartjs.org/docs/latest/
import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import { Doughnut } from 'react-chartjs-2';

import I18n from "../../../../../base/i18n.js.jsx";
import MoneyFormatter from "../../../../../utils/money_formatter.js";

import Legend from "./legend.js";

const blockStyles = makeStyles(theme => ({
  root: {
    display: "none",
    justifyContent: "center",
    ['@media (max-width: 768px)']: {
      display: "flex"
    },
  },
  content: {
    width: "62vw",
    position: "relative",
    "& canvas": {
      position: "relative",
      zIndex: "2"
    }
  },
  totalContent: {
    position: "absolute",
    zIndex: "1",
    fontSize: "14px",
    fontWeight: theme.typography.fontWeightBold,
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    top: "0px",
    left: "0px",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 30px"
  },
  totalContentRow: {
    "& + &": {
      marginTop: "5px"
    }
  }
}));

const DoughnutDiagram = props => {
  const classes = blockStyles();
  const { columns, totalCost } = props;

  const chartData = {
    datasets: [{
      data: columns.map((col) => {
        return col.percentValue
      }),
      backgroundColor: columns.map((col) => {
        return col.color
      }),
      hoverBackgroundColor: columns.map((col) => {
        return col.color
      }),
    }],
    labels: columns.map((col) => {
      return col.name
    }),
  }

  const options = {
    legend: {
      display: false
    },
    tooltips: {
      displayColors: false,
      bodyFontFamily: "Acre",
      bodyFontStyle: "500",
      bodyFontSize: "14",
      callbacks: {
        label: (tooltipItem) => {
          const { index } = tooltipItem;
          const column = columns[index];
          const { value } = column;
          return `${MoneyFormatter.format(value)} ${I18n.t("currency.euro")}`;
        }
      }
    },
    cutoutPercentage: 80,
    responsive: true, 
    maintainAspectRatio: true
  }

  return (
    <React.Fragment>
      <div className = { classes.root } >
        <div className = { classes.content } >
          <Doughnut data = { chartData }
                    options = { options }
                    width = { 200 }
                    height = { 200 } />
          <div className = { classes.totalContent } >
            <div className = { classes.totalContentRow } >
              { I18n.t("web.page.project.financing_structure.total_cost") }
            </div>
            <div className = { classes.totalContentRow } >
              { MoneyFormatter.format(totalCost)}
              &nbsp;
              { I18n.t("currency.euro") }
            </div>
          </div>
        </div>
      </div>
      <Legend columns = { columns } />
    </React.Fragment>
  );
}

export default DoughnutDiagram;